import { render, staticRenderFns } from "./DesignationCreateEditModal.vue?vue&type=template&id=8f2a2dac"
import script from "./DesignationCreateEditModal.vue?vue&type=script&lang=js"
export * from "./DesignationCreateEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports